import { PATTERNS } from 'utils'

const SATISFIED = true 
const NOT_SATISFIED = false 

const minCharacters = (value: string, length: number): boolean => {
  if (value?.length >= length) {
    return SATISFIED
  } 

  return NOT_SATISFIED 
}

const upperCaseCharacter = (value: string, length: number) => {
  if ((value?.match(PATTERNS.uppercase_letters)?.length ?? 0) >= length) {
    return SATISFIED
  }

  return NOT_SATISFIED 
}

const lowerCaseCharacter = (value: string, length: number) => {
  if ((value?.match(PATTERNS.lowercase_letters)?.length ?? 0) >= length) {
    return SATISFIED
  }

  return NOT_SATISFIED 
}

const minLetters = (value: string, length: number) => {
  if ((value?.match(PATTERNS.only_letters)?.length ?? 0) >= length) {
    return SATISFIED
  }

  return NOT_SATISFIED
}


const minNumbers = (value: string, length: number) => {
  if ((value?.match(PATTERNS.only_numbers)?.length ?? 0) >= length) {
    return SATISFIED
  }

  return NOT_SATISFIED
}

const notContentSpaces = (value: string) => {
  if (!value?.match(PATTERNS.spaces)?.length ?? 0) {
    return SATISFIED 
  }

  return NOT_SATISFIED
}

const noRepeatWords = (value: string) => {
  if (!value?.match(PATTERNS.repeat_characters)?.length ?? 0) {
    return SATISFIED
  }

  return NOT_SATISFIED
}

export default {
  minCharacters,
  upperCaseCharacter,
  lowerCaseCharacter,
  minLetters,
  minNumbers,
  notContentSpaces,
  noRepeatWords,
}
